import React from 'react';

const Icon = ({ name, size = 20, fill = true, weight = 500, color, style }) => (
  <span
    className="ms"
    style={{
      fontSize: size,
      width: size,
      height: size,
      color: color || 'inherit',
      fontVariationSettings: `'FILL' ${fill ? 1 : 0}, 'wght' ${weight}, 'GRAD' 0, 'opsz' 24`,
      ...(style || {}),
    }}
  >
    {name}
  </span>
);

export default Icon;
